﻿import {Select, SelectProps} from "@mui/material";
import React from "react";

type SortFilterSelectProps<T> = SelectProps<T> & {
}

const SortFilterSelect = <T,>(props: SortFilterSelectProps<T>) => {
  return <Select variant={'standard'}
                 displayEmpty
                 fullWidth
                 {...props} />
}

export { SortFilterSelect };
